import React, { useContext, useEffect } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';
import { Link, List, ListItem } from '@one-thd/sui-atomic-components';
import {
  params, string as stringType, fragment, customType, useDataModel, arrayOf
} from '@thd-nucleus/data-sources';

const SideNavigation = ({ componentId, componentClass, componentPosition }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('side-navigation.ready'); }, []);

  const { data, loading, error } = useDataModel('component', {
    variables: {
      id: componentId,
      componentClass
    }
  });

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  if (!data || error || loading) return null;

  const navs = data?.component?.navigationList;

  if (isMobile) return null;
  return (
    <div
      data-component-id={componentId}
      id={`${componentClass}-${componentPosition}-${componentId}`}
      data-component-name="SideNavigation"
      data-component-position={componentPosition}
      data-testid="items-list"
      data-component="SideNavigation"
      className="side-navigation sui-bg-primary sui-font-sans sui-hidden lg:sui-inline"
    >
      <List type="plain">
        {navs?.map((nav) => (
          <ListItem
            key={nav.id}
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="side-navigation__li sui-flex sui-flex-row sui-items-start
              sui-pt-2 sui-px-[2px] sui-pb-1 sui-static sui-bg-primary sui-self-stretch sui-m-0"
          >
            <Link href={nav.link} color="subtle" underline="hover">{nav.title}</Link>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

SideNavigation.propTypes = {
  componentId: PropTypes.string.isRequired,
  componentClass: PropTypes.string,
  componentPosition: PropTypes.number
};

SideNavigation.defaultProps = {
  componentPosition: 1,
  componentClass: ''
};

SideNavigation.displayName = 'SideNavigation';

SideNavigation.dataModel = {
  component: params({
    id: stringType().isRequired(),
    componentClass: customType('ComponentClass')
      .enum(['SideNavigation'])
      .isRequired()
  }).shape({
    SideNavigation: fragment().shape({
      id: stringType(),
      componentName: stringType(),
      navigationList: arrayOf({
        id: stringType(),
        title: stringType(),
        link: stringType(),
      })
    })
  })
};

export { SideNavigation };
